
import {
  join
} from '../Array.lib';
import {
  formatDateTime24hPT
} from '../Date.lib';
import Definition, {
  DEFINITION_CATEGORY__IN_OFFICE_REMOTE,
  DEFINITION_CATEGORY__LOCATION,
  DEFINITION_CATEGORY__NEGATIVE_SIGNALS,
  DEFINITION_CATEGORY__POSITIVE_SIGNALS,
  DEFINITION_CATEGORY__ROLES,
  DEFINITION_CATEGORY__TECHNICAL_SKILLS,
  DEFINITION_CATEGORY__VISA_CANDIDATE
} from '../Definition';
import globalErrorHandler from '../Error/globalErrorHandler.fun';
import {
  copyString
} from '../GenericTools.lib';
import {
  getPersonName,
  Obj
} from '../Object.lib';
import {
  COLLECTION__CANDIDATES,
  readLoopbackRecord
} from '../services/BE/loopback.api';
import {
  compileText,
  trim
} from '../String.lib';

export default async function copyCandidateInfo({
  candidateId
}) {
  try {
    const candidate = Obj(
      await readLoopbackRecord({
        collection: COLLECTION__CANDIDATES,
        where: {
          id: candidateId
        },
        limit: 1,
        fields: [
          'id',
          'firstName',
          'lastName',
          'email',
          'phone',
          'linkedinUrl',
          'githubUrl',
          'roles',
          'yearsOfExperience',
          'visa',
          'inOfficeRemoteFlags',
          'candidateLocations',
          'technicalSkills',
          'positiveSignals',
          'negativeSignals',
          'accountId',
          'createdAt'
        ],
        include: [
          {
            relation: 'account',
            scope: {
              fields: ['firstName', 'lastName']
            }
          }
        ]
      })
    )
    return copyString(
      compileText(
        `
          {{CANDIDATE__NAME}}
          {{EMAIL}}
          {{PHONE}}
          {{LINKEDIN_URL}}
          {{GITHUB_URL}}
          {{ROLES}}
          {{YEARS_OF_EXPERIENCE}}
          {{VISA}}
          {{REMOTE_FLAGS}}
          {{HOME_LOCATION}}
          {{TECH_SKILLS}}
          {{POSITIVE_SIGNALS}}
          {{NEGATIVE_SIGNALS}}
          {{RECRUITER__NAME}}
          {{CANDIDATE__CREATED_DATE}}
        `,
        {
          CANDIDATE__NAME: (
            getPersonName(candidate) ||
            '[candidate name]'
          ),
          EMAIL: (
            candidate.email || '[email]'
          ),
          PHONE: (
            candidate.phone
              ? `✆ ${candidate.phone}`
              : '[phone]'
          ),
          LINKEDIN_URL: '', // candidate.linkedInURL || '[linkedin url]',
          GITHUB_URL: '', // candidate.gitHubURL || '[github url]',
          ROLES: join(
            Definition.getLabels(
              DEFINITION_CATEGORY__ROLES,
              candidate.roles
            )
          ) || '[roles]',
          YEARS_OF_EXPERIENCE: (
            candidate.yearsOfExperience
              ? `${candidate.yearsOfExperience}yrs`
              : '[years of experience]'),
          VISA: Definition.getLabel(
            DEFINITION_CATEGORY__VISA_CANDIDATE,
            candidate.visa
          ) || '[visa]',
          REMOTE_FLAGS: join(
            Definition.getLabels(
              DEFINITION_CATEGORY__IN_OFFICE_REMOTE,
              candidate.inOfficeRemoteFlags)) || '[remote flags]',
          HOME_LOCATION: join(
            Definition.getLabels(
              DEFINITION_CATEGORY__LOCATION,
              candidate.candidateLocations
            )
          ) || '[home location]',
          TECH_SKILLS: join(
            Definition.getLabels(
              DEFINITION_CATEGORY__TECHNICAL_SKILLS,
              candidate.technicalSkills
            )
          ) || '[tech skills]',
          POSITIVE_SIGNALS: join(
            Definition.getLabels(
              DEFINITION_CATEGORY__POSITIVE_SIGNALS,
              candidate.positiveSignals
            )
          ) || '[positive signals]',
          NEGATIVE_SIGNALS: join(
            Definition.getLabels(
              DEFINITION_CATEGORY__NEGATIVE_SIGNALS,
              candidate.negativeSignals
            )
          ) || '[negative signals]',
          RECRUITER__NAME: getPersonName(
            candidate.account
          ) || '[recruiter name]',
          CANDIDATE__CREATED_DATE: formatDateTime24hPT(
            candidate.createdAt
          ) || '[create date]',
        }
      ).split('\n').map(v => trim(v)).filter(v => !!v).join('\t')
    );
  }
  catch (error) {
    globalErrorHandler(error);
  }
}
